<template>
    <div class="header">
        <div class="header_top">
            <div class="wrapper-left">
                <!-- <img style="vertical-align: middle;" src="./images/logo.png" /> -->
            </div>
            <div class="wrapper-right">
                <span>
                    <el-select v-model="language" style="width:80px" size="small" placeholder="请选择">
                       <el-option  v-for="item in languages"  :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </span>
                <div style="display:inline-block">
                    <div class="nav-menu" style="padding-top: 20px;height:60px;" v-if="ticketInfo.UserName">
                        <div style="height:20px;line-height: 20px;">
                            <router-link class=" menu-li" :to="{name:'UserMain'}">
                                <span class="index_exit" style="cursor: pointer">{{ticketInfo.UserName}}</span>
                            </router-link>
                            <span class=" index_exit" style="cursor: pointer" @click="exit">&nbsp;&nbsp;退出</span>
                        </div>
                        <div>我的订单</div>
                    </div>
                    <div class="nav-menu" style="height:40px;line-height: 40px;" v-else>
                        <span @click="login" style="cursor: pointer;padding: 10px" class="index_login">登录</span>
                        <span>/</span>
                        <router-link to="/User/Register" class="index_exit" style="cursor: pointer;padding: 10px">注册</router-link>
                    </div>
                </div>
                <span style="color:#4f83cc;padding-top:40px;display:inline-block;height:60px;">App下载</span>
            </div>
        </div>
        <div class="header-botton">
            <el-radio-group @change='changeBookType' v-model="BookType">
                <el-radio class="BookType" :class="{'radioBg':item.CategoryID==BookType?true:false}" v-for="item in categorys.BookingType"
                    :key="item.CategoryID" :value="item.CategoryID" :label="item.CategoryID">{{item.CategoryTitle}}
                    <a v-if="item.CategoryID==BookType" class="test1"></a>
                </el-radio>
            </el-radio-group>
        </div>
    </div>
</template>
<style scoped>
    .BookType {
        width: 80px;
        display: inline-block;
        text-align: center;
        line-height: 40px;
        color: #fff
    }

    .test1 {
        display: inline-block;
        width: 0;
        height: 0;
        border-right: 5px solid transparent;
        border-bottom: 5px solid #fff;
        border-left: 5px solid transparent;
        bottom: 0;
        position: absolute;
        left: 50%;
        margin-left: -5px
    }

    .header_top {

        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        padding: 0 70px 0 30px;
    }

    .header_top .wrapper-left {
        width: 80%;
    }

    .header_top .wrapper-right {
        width: 20%;
        display: flex;
        height: 60px;
        align-items: center;
        justify-content: space-between;
    }

    .header-botton {
        height: 40px;
        background-color: #2577e3;
        padding: 0 0 0 280px;
    }

</style>
<style>
    .header .header-botton .el-radio__input.is-checked .el-radio__inner {
        background: rgba(255, 255, 255, 0);
    }

    .header .header-botton .el-radio__inner {
        border: 1px solid #fffde4;
    }

    .header .header-botton .el-radio__inner,
    .header .el-radio__input.is-disabled.is-checked .el-radio__inner::after {
        background-color: #2577e3
    }

    .header .header-botton .el-radio__input.is-checked .el-radio__inner {
        border-color: #fffde4;
    }

    .header .radioBg {
        background-color: #fc6c26
    }

    .header .el-input__inner {
        border: none;
    }

</style>
<script>
    import categorys from 'utils/categorys.js'
    import {
        mapGetters
    } from 'vuex'
    export default {
        data() {
            return {
                categorys: categorys,
                languages: [{
                    value: '1',
                    label: '中文'
                }, {
                    value: '2',
                    label: '英文'
                }],
                BookType: categorys.types.BookingType.OnBusiness,
                language: '中文'
            }
        },
        computed: {
            ...mapGetters(['ticketInfo', ])
        },
        methods: {
            // showUserList() {
            //     $("#userListContent").css("display", "block");
            // },
            // closeUserList() {
            //     $("#userListContent").css("display", "none");
            // },
            changeBookType(value) {
                this.$emit('BookTypes', value)
            },
            exit() {
                var __self = this;
                __self.$store.dispatch("logout").then(function () {
                    location.href = "/"
                }).catch(function () {
                    location.href = "/"
                });
            },
            login() {
                this.$router.push({
                    path: '/login',
                    query: {
                        redirect: this.$route.fullPath
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// hearder1.vue?8de9d5de